"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordReset = void 0;
const react_1 = __importDefault(require("react"));
const LoginForm_1 = __importDefault(require("./LoginForm"));
const LabelledInput_1 = __importDefault(require("./LabelledInput"));
function PasswordReset(props) {
    const [password, setPassword] = react_1.default.useState('');
    const { errorMessage } = props;
    const errorMessageDisplay = errorMessage && (react_1.default.createElement("div", { className: "error message-ticker margin-bottom-20" },
        "Error: ",
        errorMessage));
    return (react_1.default.createElement("div", { id: "container" },
        react_1.default.createElement(LoginForm_1.default, { title: "Reset Password", footer: (react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-xs-12 text-center" },
                    react_1.default.createElement("a", { className: "login-link", onClick: () => window.location.href = '/' }, "Back to Login")))), action: "/realtime/user/password/reset/token", method: "POST" },
            errorMessageDisplay,
            react_1.default.createElement("p", null, "Choose a new password for your account."),
            react_1.default.createElement(LabelledInput_1.default, { id: "new-password", type: "password", name: "password", label: "New Password", value: password, onChange: setPassword, required: true }),
            react_1.default.createElement("input", { type: "hidden", name: "token", value: props.token }),
            react_1.default.createElement("div", { className: "row row-20m" },
                react_1.default.createElement("div", { className: "col-xs-offset-4 col-xs-4 text-center" },
                    react_1.default.createElement("button", { type: "submit", className: "btn btn-login btn-action" }, "Send"))))));
}
exports.PasswordReset = PasswordReset;
